var module = angular.module('octopusApp.configuration');

module.controller('TeamAddExternalRoleDialogController', function($scope, busy, $uibModalInstance) {

  $scope.role = {};

  $scope.close = function() {
    $uibModalInstance.close();
  };

  $scope.save = function () {
    $uibModalInstance.close({ Id: $scope.role.id, DisplayName: $scope.role.displayName, DisplayIdAndName: true });
  };
});




//////////////////
// WEBPACK FOOTER
// ./app/areas/configuration/teams/controllers/team_add_external_role_dialog_controller.js
// module id = 7161571297221569
// module chunks = 1